<template>
  <div class="performance_container">
    <div v-if="list.length > 0">
      <div class="main">
        <!-- <div class="list" id="list" v-for="(item, index) in list" :key="index"> -->
        <div class="my_hire_list">
          <div class="SalesPerformance_item betweentop" id="my_hire_record" v-for="(item, index) in list" :key="index">
            <div class="between">
              <div class="Sales_i">
                <div class="ellipsis name my_hier_size">
                  {{ item.saleYear + "年" + item.saleMonth + "月" }}
                </div>
              </div>
              <div class="betweenBottoms my_hier_size">{{ item.quantity }}盒</div>
            </div>
            <div class="SpecialtyGoods" v-if="item.details.length">
              <div>特殊产品展示</div>
              <div class="between topGoods" v-for="v in item.details" :key="v.goodsId">
                <div class="goodsLeft">{{ v.name }}</div>
                <div>x{{ v.quantity }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="list_l">{{ item.month }}年</div>
          <div>{{ item.percentage }}484684</div> -->
        <!-- </div> -->
      </div>
      <div class="footerProfit">展示最近6个月的数据</div>
    </div>
    <div v-else class="noShares">
      <div class="noSalePage">
        <img src="../../../../assets/images/noSale.png" alt />
      </div>
      <div class="noShareText">暂无业绩</div>
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { Toast, Dialog, List, PullRefresh, NavBar, Icon, overlay } from "vant";
import loading from "../../../components/loading/loading";
import { mapGetters, mapActions } from "vuex";
import saleService from "../../../api/salesPerformance/index";
export default {
  name: "performance",
  data() {
    return {
      totalPrice: 0,
      isLoading: false, //loading状态
      list: [],
    };
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [overlay.name]: overlay,
    loading,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    this.init();
  },
  methods: {
    formatPrice(price) {
      return price.toFixed(2);
      // if (price >= 1) {
      //   return price.toFixed(2);
      // } else {
      //   return price;
      // }
    },
    init() {
      saleService
        .GetMySalesRecord()
        .then((response) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 600);
          if (response.statusCode == 200) {
            this.list = response.data;
          } else {
            Toast(response.errors);
          }
        })
        .catch((error) => {
          // Toast(error);
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
    },
  },
};
</script>
<style lang="less" scoped>
// @deep: ~">>>";
.performance_container {
  height: 100vh;

  .SalesProduct {
    margin-top: 8px;
  }

  .SpecialtyGoods {
    color: rgba(71, 85, 105, 1);
    font-size: 14px;
    line-height: 22px;
    padding-top: 16px;
    margin-top: 16px;
    border-top: 1px solid rgba(226, 232, 240, 1);
  }

  .goodsLeft {
    margin-right: 40px;
  }

  .topGoods {
    padding-top: 12px;
  }

  .main {
    padding-top: 12px;
  }

  .my_hire_list {
    padding: 0 12px;

    .SalesPerformance_item {
      padding: 20px;
      // height: 40px;
      background: #ffffff;
      box-shadow: 0px 4px 8px 0px #e6e6e6;
      border-radius: 8px;
      margin-bottom: 8px;
    }

  }

  .footerProfit {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 12px;
    color: rgba(200, 200, 200, 1);
    text-align: center;
    padding: 8px;
  }

  .noShares {
    height: 100;
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #92909a;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .noSalePage {
    width: 80px;
    margin: auto;
  }

  .noShareText {
    padding-top: 24px;
  }
}
</style>
